import { useCallback, useEffect, useState } from 'react';

function useBannerDismissal(storageKey) {
  const [dismissedBanners, setDismissedBanners] = useState({});

  // Load dismissed banners from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem(storageKey);
    if (stored) {
      try {
        setDismissedBanners(JSON.parse(stored));
      } catch (error) {
        console.error(
          `Error parsing dismissed banners from localStorage (${storageKey}):`,
          error,
        );
      }
    }
  }, [storageKey]);

  // Save dismissed banners to localStorage whenever state changes
  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(dismissedBanners));
  }, [dismissedBanners, storageKey]);

  const dismissBanner = useCallback((bannerKey) => {
    setDismissedBanners((prev) => ({
      ...prev,
      [bannerKey]: true,
    }));
  }, []);

  const resetBanner = useCallback((bannerKey) => {
    setDismissedBanners((prev) => {
      const newState = { ...prev };
      delete newState[bannerKey];
      return newState;
    });
  }, []);

  const resetAllBanners = useCallback(() => {
    setDismissedBanners({});
  }, []);

  const isBannerDismissed = useCallback(
    (bannerKey) => {
      return dismissedBanners[bannerKey] === true;
    },
    [dismissedBanners],
  );

  return {
    dismissedBanners,
    dismissBanner,
    resetBanner,
    resetAllBanners,
    isBannerDismissed,
  };
}

export default useBannerDismissal;
